import './App.scss';
import 'react-lazy-load-image-component/src/effects/blur.css';
import ApiServiceContextProvider from './context/api/provider';
import CandleContextProvider from '../src/context/candle/provider'
import PostsContextProvider from './context/posts/provider';
import DynamicCssLoader from './DynamicCssLoader';
import AppRouter from './AppRouter';
import {useSettingsContext} from './context/settings/useSettingsContext';
import ConditionalReCaptchaProvider from './ConditionalRecaptchaProvider';

function App() {
    const {
        loadDefaultFont,
    } = useSettingsContext();

    return (
        <ConditionalReCaptchaProvider>
            <ApiServiceContextProvider useMock={false}>
                <PostsContextProvider>
                    <CandleContextProvider>
                        <DynamicCssLoader />
                        <div className={`empriva-condoleanceregister-app empriva-condoleanceregister-root ${loadDefaultFont ? 'cr-default-font' : ''}`}>
                            <AppRouter />
                        </div>
                    </CandleContextProvider>
                </PostsContextProvider>
            </ApiServiceContextProvider>
        </ConditionalReCaptchaProvider>
    );
}

export default App;
